module.exports = __webpack_public_path__ + "img/03.121e6816.jpg";